import { createSlice  } from '@reduxjs/toolkit'

const initialState = {
    countryList: {
      requesting: false,
      items: [],
      error: null,
      success: false,
      filters: {},
    },
    employeeList: {
      requesting: false,
      items: [],
      error: null,
      success: false,
      filters: {},
    },
  };

export const optionlistSlice = createSlice({
  name: 'optionlist',
  initialState,
  reducers: {
    getCountryList: (state, action) => {		
      state.countryList.requesting = true;
      state.countryList.error = null;
      state.countryList.items = [];
      state.countryList.success = false;
      state.countryList.filters = action.payload;
    },
    getCountryListSuccess: (state, action) => {
      state.countryList.requesting = false;        
      state.countryList.items = action.payload;
      console.log(state.countryList.items);
      state.countryList.success = true; 
    },
    getCountryListFail: (state, action) => {        
      state.countryList.requesting = false;
      state.countryList.error = action.payload;
    },

    getEmployeeList: (state, action) => {		
      state.employeeList.requesting = true;
      state.employeeList.error = null;
      state.employeeList.items = [];
      state.employeeList.success = false;
      state.employeeList.filters = action.payload;
    },
    getEmployeeListSuccess: (state, action) => {
      state.employeeList.requesting = false;        
      state.employeeList.items = action.payload;
      console.log(state.employeeList.items);
      state.employeeList.success = true; 
    },
    getEmployeeListFail: (state, action) => {        
      state.employeeList.requesting = false;
      state.employeeList.error = action.payload;
    },
  },
})

export const { 
    getCountryList, getCountryListSuccess, getCountryListFail,
    getEmployeeList, getEmployeeListSuccess, getEmployeeListFail,
} = optionlistSlice.actions

export default optionlistSlice.reducer


